/* tslint:disable */
/* eslint-disable */
/**
 * FraudFighter API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdminGetTeamRequest
 */
export interface AdminGetTeamRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminGetTeamRequest
     */
    teamId?: string;
}

export function AdminGetTeamRequestFromJSON(json: any): AdminGetTeamRequest {
    return AdminGetTeamRequestFromJSONTyped(json, false);
}

export function AdminGetTeamRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminGetTeamRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'teamId': !exists(json, 'teamId') ? undefined : json['teamId'],
    };
}

export function AdminGetTeamRequestToJSON(value?: AdminGetTeamRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'teamId': value.teamId,
    };
}


